export default __webpack_public_path__ + "static/media/approve.2d2617cd.svg";